const defaultState = {
	//Main
	plants: [],
	plantCd: '',

	queueTypes: [],
	queueType: 'All',
	remained: false,
	queueRecordCountList: []
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
